<template>
</template>
<script>
	export default {
		data() {
			let vm = this;
			return {
				element: null,
				resources: {
					zIndex: {
						name: 'zIndex',
						defaultValue: '',
						labelDesc: 'zIndex',
						callback: function () {
							vm.resources.zIndex.defaultValue = this.value;
							vm.element.internal_config.zIndex = this.value;

						},
					},
          maxWidth: {
						name: 'maxWidth',
						defaultValue: '500',
						min: '200',
						max: '768',
						labelDesc: 'max-width-tablet',
						callback: function () {
							vm.resources.maxWidth.defaultValue = this.value;
							vm.element.internal_config.maxWidth = this.value + 'px';

						},
					},
          height: {
            name: 'height',
            defaultValue: '300',
            min: '1',
            max: '1000',
            labelDesc: 'height',
            callback: function () {
              vm.resources.height.defaultValue = this.value;
              vm.element.internal_config.height = this.value + 'px';


            },
          },
          width: {
            name: 'width',
            defaultValue: '300',
            min: '1',
            max: '1000',
            labelDesc: 'width',
            callback: function () {
              vm.resources.width.defaultValue = this.value;
              vm.element.internal_config.width = this.value + 'px';


            },
          },
					text: {
						name: 'text',
						defaultValue: '',
						labelDesc: 'button-headline',
						canRemove: false,
						callback: function () {
							vm.resources.text.defaultValue = this.value;
							vm.element.internal_config.text = this.value;

							vm.element.internal_config.backgroundColor = vm.resources.backgroundColor.defaultValue;
						},
					},
					subtext: {
						name: 'subtext',
						defaultValue: '',
						labelDesc: 'subtext',
						canRemove: false,
						callback: function () {
							vm.resources.subtext.defaultValue = this.value;
							vm.element.internal_config.subtext = this.value;

							vm.element.internal_config.backgroundColor = vm.resources.backgroundColor.defaultValue;

							vm.element.rebuild();
						},
					},
					border: {
						name: 'border',
						defaultValue: '1px solid black',
						min: '0',
						max: '50',
						labelDesc: 'border',
						callback: function () {
							let value = this.value + 'px ' + this.value2 + ' ' + this.value3;

							vm.resources.border.defaultValue = value;
							vm.element.internal_config.border = value;
						},
					},
					borderRadius: {
						name: 'borderRadius',
						defaultValue: '0 0 0 0',
						min: '0',
						max: '360',
						labelDesc: 'borderRadius',
						callback: function () {

							let value = this.v1 + 'px ' + this.v2 + 'px ' + this.v3 + 'px ' + this.v4 + 'px';

							vm.resources.borderRadius.defaultValue = value;
							vm.element.internal_config.borderRadius = value;
						},
					},
          hover: {
            name: 'hover',
            defaultValue: true,
            labelDesc: 'resource-hover',
            callback: function () {
              vm.resources.hover.defaultValue = this.value;
              vm.element.internal_config.hover = this.value;
              this.$root.$emit('showResourceRightSideBar', 'backgroundColorHover', this.value);
              this.$root.$emit('showResourceRightSideBar', 'textColorHover', this.value);
            },
          },
					backgroundColor: {
						name: 'backgroundColor',
						defaultValue: '#ffffff',
						gradient: true,
						labelDesc: 'resource-bg-color',
						callback: function () {
							vm.resources.backgroundColor.defaultValue = this.colorValue;
							vm.element.internal_config.backgroundColor = this.colorValue;
						},
					},
					backgroundColorHover: {
						name: 'backgroundColorHover',
						defaultValue: '#ffffff',
						gradient: true,
						labelDesc: 'resource-bg-color-hover',
						callback: function () {
							vm.resources.backgroundColorHover.defaultValue = this.colorValue;
							vm.element.internal_config.backgroundColorHover = this.colorValue;
						},
					},
					textColorHover: {
						name: 'textColorHover',
						defaultValue: '#ffffff',
						labelDesc: 'resource-bg-text-hover',
						callback: function () {
							vm.resources.textColorHover.defaultValue = this.colorValue;
							vm.element.internal_config.textColorHover = this.colorValue;
						},
					},
					src: {
						defaultValueOrigin: '',
						defaultValueSize: '',
						defaultValueRepeat: '',

						name: 'src',
						defaultValue: '',
						labelDesc: 'bg-image',
						canRemove: true,
						callback: function () {
							vm.resources.src.defaultValue = this.value;
							vm.resources.src.defaultValueOrigin = this.origin;
							vm.resources.src.defaultValueRepeat = this.repeat;
							vm.resources.src.defaultValueSize = this.size;

							vm.element.internal_config.backgroundImage = this.value;
							vm.element.internal_config.backgroundOrigin = this.origin;
							vm.element.internal_config.backgroundRepeat = this.repeat;
							vm.element.internal_config.backgroundSize = this.size;


							//force apply new bg
							let color = vm.element.internal_config.backgroundColor;
							vm.element.internal_config.backgroundColor = '#FFFFFF';
							vm.element.internal_config.backgroundColor = color;
						},
					},
					icon: {
						name: 'icon',
						defaultIcon: '',
						defaultPosition: 'left',
						labelDesc: 'icon',
						callback: function () {

							vm.resources.icon.defaultIcon = this.iconSelected;
							vm.resources.icon.defaultPosition = this.position;

							vm.element.internal_config.icon = this.iconSelected;
							vm.element.internal_config.iconPosition = this.position;

							vm.element.buildIcon();
						},
					},
					textStyle: {
						name: 'textStyle',
						defaultFamily: '',
						defaultSize: '',
						showSizeMobile: true,
						shitOptions: true,
						defaultSizeMobile: '',
						defaultColor: '',
						defaultAlign: '',
						defaultWeight: '',
						defaultStroke: '',
						defaultStyle: '',
						labelDesc: 'textStyle',
						callback: function () {

							vm.resources.textStyle.defaultFamily = this.family;
							vm.element.internal_config.textStyle.family = this.family;

							vm.resources.textStyle.defaultSize = this.size + 'px';
							vm.element.internal_config.textStyle.size = this.size + 'px';

							vm.resources.textStyle.defaultSizeMobile = this.sizeMobile + 'px';
							vm.element.internal_config.textStyle.sizeMobile = this.sizeMobile + 'px';

							vm.resources.textStyle.defaultColor = this.color;
							vm.element.internal_config.textStyle.color = this.color;

							vm.resources.textStyle.defaultAlign = this.align;
							vm.element.internal_config.textStyle.align = this.align;

							vm.resources.textStyle.defaultWeight = this.weight;
							vm.element.internal_config.textStyle.weight = this.weight;

							vm.resources.textStyle.defaultStyle = this.style;
							vm.element.internal_config.textStyle.style = this.style;

							vm.resources.textStyle.defaultStroke = this.stroke;
							vm.element.internal_config.textStyle.stroke = this.stroke;


						},
					},
          cursorType: {
            name: 'cursorType',
            defaultValue: '',
            labelDesc: 'cursorType',
            options: [
              {name: vm.$t('ct-option-menu-mobile-effect-none'), value: '', selected: 'selected', disabled: false},
              {name: vm.$t('ct-option-cursor-type-crosshair'), value: 'crosshair', selected: false, disabled: false},
              {name: vm.$t('ct-option-cursor-type-pointer'), value: 'pointer', selected: false, disabled: false},
              {name: vm.$t('ct-option-cursor-type-text'), value: 'text', selected: false, disabled: false},
              {name: vm.$t('ct-option-cursor-type-wait'), value: 'wait', selected: false, disabled: false},
              {name: vm.$t('ct-option-cursor-type-help'), value: 'help', selected: false, disabled: false},
            ],
          callback: function() {
            vm.resources.cursorType.defaultValue = this.value;
            vm.element.internal_config.cursorType = this.value;
          }
        },

					subTextStyle: {
						name: 'subTextStyle',
						defaultFamily: '',
						defaultSize: '',
						defaultColor: '',
						defaultSizeMobile: '',
						shitOptions: true,
						showSizeMobile: true,
						defaultStroke: '',
						defaultAlign: '',
						labelDesc: 'subTextStyle',
						callback: function () {

							vm.resources.subTextStyle.defaultFamily = this.family;
							vm.element.internal_config.subTextStyle.family = this.family;

							vm.resources.subTextStyle.defaultSize = this.size + 'px';
							vm.element.internal_config.subTextStyle.size = this.size + 'px';

							vm.resources.subTextStyle.defaultSizeMobile = this.sizeMobile + 'px';
							vm.element.internal_config.subTextStyle.sizeMobile = this.sizeMobile + 'px';

							vm.resources.subTextStyle.defaultColor = this.color;
							vm.element.internal_config.subTextStyle.color = this.color;

							vm.resources.subTextStyle.defaultAlign = this.align;
							vm.element.internal_config.subTextStyle.align = this.align;

							vm.resources.subTextStyle.defaultWeight = this.weight;
							vm.element.internal_config.subTextStyle.weight = this.weight;

							vm.resources.subTextStyle.defaultStyle = this.style;
							vm.element.internal_config.subTextStyle.style = this.style;

							vm.resources.subTextStyle.defaultStroke = this.stroke;
							vm.element.internal_config.subTextStyle.stroke = this.stroke;

						},
					},
					padding: {
						name: 'padding',
						defaultLeft: '15',
						defaultTop: '15',
						defaultRight: '15',
						defaultBottom: '15',
						min: '0',
						max: '100',
						labelDesc: 'padding',
						callback: function () {
							vm.resources.padding.defaultLeft = this.l;
							vm.element.internal_config.paddingLeft = this.l + 'px';

							vm.resources.padding.defaultTop = this.t;
							vm.element.internal_config.paddingTop = this.t + 'px';

							vm.resources.padding.defaultRight = this.r;
							vm.element.internal_config.paddingRight = this.r + 'px';

							vm.resources.padding.defaultBottom = this.b;
							vm.element.internal_config.paddingBottom = this.b + 'px';
						},
					},
					boxShadow: {
						name: 'boxShadow',
						defaultValue: '0 0 0 0 black initial',
						min: '0',
						max: '50',
						labelDesc: 'boxShadow',
						callback: function () {

							let value = this.h + 'px ' + this.v + 'px ' + this.b + 'px ' + this.s + 'px ' + this.colorValue + ' ' + (this.i === true ? 'inset' : '');

							vm.resources.boxShadow.defaultValue = value;
							vm.element.internal_config.boxShadow = value;
						},
					},
				}
			}
		},
		methods: {
			setValuesData(data) {
				this.element = data;

				// this.resources.width.defaultValue = parseInt(data.internal_config.width);
				// this.resources.height.defaultValue = parseInt(data.internal_config.height);
        this.resources.height.defaultValue = parseInt(data.internal_config.height);
        this.resources.width.defaultValue = parseInt(data.internal_config.width);

				this.resources.text.defaultValue = data.internal_config.text;
				this.resources.subtext.defaultValue = data.internal_config.subtext;
				this.resources.maxWidth.defaultValue = parseInt(data.internal_config.maxWidth);

				this.resources.border.defaultValue = data.internal_config.border;
				this.resources.borderRadius.defaultValue = data.internal_config.borderRadius;
				this.resources.boxShadow.defaultValue = data.internal_config.boxShadow;

				this.resources.hover.defaultValue = data.internal_config.hover;
				this.resources.backgroundColor.defaultValue = data.internal_config.backgroundColor;
				this.resources.backgroundColorHover.defaultValue = data.internal_config.backgroundColorHover;
				this.resources.textColorHover.defaultValue = data.internal_config.textColorHover;
				this.resources.src.defaultValue = data.internal_config.backgroundImage;
				this.resources.src.defaultValueOrigin = data.internal_config.backgroundOrigin;
				this.resources.src.defaultValueRepeat = data.internal_config.backgroundRepeat;
				this.resources.src.defaultValueSize = data.internal_config.backgroundSize;

				this.resources.textStyle.defaultFamily = data.internal_config.textStyle.family;
				this.resources.textStyle.defaultSize = data.internal_config.textStyle.size;
				this.resources.textStyle.defaultSizeMobile = data.internal_config.textStyle.sizeMobile
				this.resources.textStyle.defaultColor = data.internal_config.textStyle.color;
				this.resources.textStyle.defaultAlign = data.internal_config.textStyle.align;
				this.resources.textStyle.defaultWeight = data.internal_config.textStyle.weight;
				this.resources.textStyle.defaultStyle = data.internal_config.textStyle.style;
				this.resources.textStyle.defaultStroke = data.internal_config.textStyle.stroke;

				this.resources.subTextStyle.defaultFamily = data.internal_config.subTextStyle.family;
				this.resources.subTextStyle.defaultSize = data.internal_config.subTextStyle.size;
				this.resources.subTextStyle.defaultSizeMobile = data.internal_config.subTextStyle.sizeMobile;
				this.resources.subTextStyle.defaultColor = data.internal_config.subTextStyle.color;
				this.resources.subTextStyle.defaultAlign = data.internal_config.subTextStyle.align;
				this.resources.subTextStyle.defaultWeight = data.internal_config.subTextStyle.weight;
				this.resources.subTextStyle.defaultStyle = data.internal_config.subTextStyle.style;
				this.resources.subTextStyle.defaultStroke = data.internal_config.subTextStyle.stroke;

				this.resources.icon.defaultIcon = data.internal_config.icon;
				this.resources.icon.defaultPosition = data.internal_config.iconPosition;

				this.resources.padding.defaultLeft = parseInt(data.internal_config.paddingLeft);
				this.resources.padding.defaultTop = parseInt(data.internal_config.paddingTop);
				this.resources.padding.defaultRight = parseInt(data.internal_config.paddingRight);
				this.resources.padding.defaultBottom = parseInt(data.internal_config.paddingBottom);

        this.resources.cursorType.defaultValue =   data.internal_config.cursorType;
			},
			getValuesData() {
				return this.resources;
			}
		},
	}
</script>



// WEBPACK FOOTER //
// src/components/editor/apps/Button/Resources.vue